import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import React, { Component } from 'react';

class TaxRow extends Component {
    render() {
        return (
            <TableContainer component={Paper}>
                <Table size="small" aria-label="a dense table">
                    <TableHead>
                        <TableRow>
                            <TableCell>Sorszám</TableCell>
                            <TableCell>Adónem szám</TableCell>
                            <TableCell>Adónem</TableCell>
                            <TableCell>Összeg</TableCell>
                            <TableCell>Megjegyzés</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableRow key="new">
                            <TableCell> {this.props.row.publicId}</TableCell>
                            <TableCell>{this.props.row.taxTypePublicId}</TableCell>
                            <TableCell>{this.props.row.taxTypeName}</TableCell>
                            <TableCell>{this.props.row.amount}</TableCell>
                            <TableCell>{this.props.row.comment}</TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>
        )
    }
}
export default TaxRow;